// extracted by mini-css-extract-plugin
export default {"options-btn":"OptionsDropdown_options-btn__I6ZSY"};